const buyer = require('od-modules/xsell/data/buyer');
const travellers = require('./travellers');
const itineraryDates = require('../dates');
const accommodation = require('./accommodation');

const ONE_WAY = 'ONE_WAY';
const ROUND_TRIP = 'ROUND_TRIP';
const DEFAULT_CURRENCY = 'EUR';


function itinerary(itineraryData) {
    const itineraryPrototype = {};

    itineraryPrototype.getArrivalSegment = function() {
        return this._segments[0];
    };

    itineraryPrototype.getDepartureSegment = function() {
        return Odigeo._.get(this._segments, '[1]', false);
    };

    itineraryPrototype.getSegment = function(index) {
        return this._segments[index];
    };

    itineraryPrototype.getSegments = function() {
        return this._segments.slice();
    };

    itineraryPrototype.isOneWay = function() {
        return Odigeo._.get(this._segments, 'length') === 1;
    };

    itineraryPrototype.getItineraryType = function() {
        return this.isOneWay(this._segments) ? ONE_WAY : ROUND_TRIP;
    };

    itineraryPrototype.getBookingStatus = function() {
        return Odigeo._.get(itineraryData, 'myTripStatus', '').toLowerCase();
    };

    itineraryPrototype.getNumberOfPassengers = function() {
        return Odigeo._.get(itineraryData, 'travellers.length', 1);
    };

    itineraryPrototype.getPassengers = function() {
        return this._passengers;
    };

    itineraryPrototype.getPrice = function() {
        return Odigeo._.get(itineraryData, 'price.amount', 0);
    };

    itineraryPrototype.hasHotelBooked = function() {
        return !Odigeo._.isEmpty(itineraryData.accommodationBooking);
    };

    itineraryPrototype.getCurrencyCode = function() {
        return Odigeo._.get(itineraryData, 'price.currency', DEFAULT_CURRENCY);
    };

    itineraryPrototype.getPnr = function() {
        const arrivalSection = Odigeo._.last(Odigeo._.get(itineraryData, 'itineraryBookings.itinerarySegments[0].sections', []));
        return Odigeo._.get(arrivalSection, 'section.pnr', '');
    };

    itineraryPrototype.getBookingId = function() {
        return Odigeo._.get(itineraryData, 'bookingBasicInfo.id');
    };

    itineraryPrototype.getBuyer = function() {
        return buyer(itineraryData.buyer);
    };

    itineraryPrototype.getTravellers = function() {
        return travellers(itineraryData.travellers);
    };

    itineraryPrototype.isSameDayReturn = function() {
        if (this.isOneWay()) {
            return false;
        }

        const arrivalDate = new Date(this.getArrivalSegment().getArrivalLeg().getArrivalDate());
        const departureDate = new Date(this.getDepartureSegment().getDepartureLeg().getDepartureDate());

        return (arrivalDate.getDate() === departureDate.getDate() && arrivalDate.getMonth() === departureDate.getMonth());
    };

    itineraryPrototype.getItineraryDates = function(product) {
        return itineraryDates(this, product);
    };

    itineraryPrototype.getAccommodation = function() {
        return accommodation(itineraryData.accommodationBooking);
    };

    return itineraryPrototype;
}

module.exports = itinerary;
